import moment from 'moment';

import { createAdditionalQuote } from '../components/API/Model';

export const quoteTypeMapper = {
	['Homeowner_value']: ['HO5', 'HO3', 'DF3-DO', 'DF1'],
	['Condominium_Owner_value']: ['HO6'],
	['Renter_value']: ['HO4'],
	['Landlord_value']: ['DF3-DL', 'DF1'],
};

export function getPolicyType(covALimit) {
	const ownerType = window.localStorage.getItem('owner_type');
	let policyType;
	if (ownerType === 'OwnerCondo') {
		policyType = ['HO6'];
		localStorage.setItem(
			'applicableQuoteTypes',
			JSON.stringify(policyType)
		);
	} else if (ownerType === 'Renter') {
		policyType = ['HO4'];
		localStorage.setItem(
			'applicableQuoteTypes',
			JSON.stringify(policyType)
		);
	} else if (ownerType === 'Landlord') {
		policyType = getLandlordMatchingType(covALimit);
	} else if (ownerType === 'OwnerSingleFamilyHome') {
		policyType = getHomeownerMatchingType(covALimit);
	}

	return policyType[0];
}

export function getUsageType(quoteType, occupancyType, rentalExposure = null) {
	const usageTypeByRentalExposure = (re) => {
		switch (re) {
			case '1':
				return 'Primary Residence, Not Rented';
			case '2':
				return 'Secondary Residence, Rented';
		}
	};

	const usageTypeByOccupancyType = (ot) => {
		switch (ot) {
			case 'Owner Occupied':
				return 'Primary Residence, Not Rented';
			case 'Immediate Family':
				return usageTypeByRentalExposure(rentalExposure);
			case 'Tenant Occupied':
				return 'Rental Only';
			case 'Vacant':
				return 'Vacant';
			default:
				return 'Primary Residence, Not Rented';
		}
	};

	switch (quoteType) {
		case 'DF1':
			return usageTypeByOccupancyType(occupancyType);
		case 'HO6':
			switch (occupancyType) {
				case 'Owner Occupied':
					return 'Primary Residence, Not Rented';
				case 'Immediate Family':
					return rentalExposure === '2'
						? 'Secondary Residence, Rented'
						: 'Secondary Residence, Not Rented';
				case 'Tenant Occupied':
					return 'Rental Only';
				default:
					return 'Primary Residence, Not Rented';
			}
		default:
			return null;
	}
}

export function getHO6OccupancyType(occupancyType) {
	switch (occupancyType) {
		case 'Owner Occupied':
		case 'Immediate Family':
			return 'Owner Occupied';
		case 'Tenant Occupied':
			return 'Tenant Occupied';
		default:
			return 'Owner Occupied';
	}
}

export function getBusinessLine(quoteType) {
	switch (quoteType) {
		case 'DF1':
		case 'DF3-DO':
		case 'DF3-DL':
			return 'Dwelling';
		default:
			return 'Homeowners';
	}
}

// type MatchType = 'HO5' | 'HO3' | 'DF3-DO' | 'DF1';
// type MatchLandlordType = 'DF3-DL' | 'DF1';

export function getHomeownerMatchingType(value) {
	const matches = new Set();
	const occupancyType = window.localStorage.getItem('occupancy_type');
	const rentalExposure = window.localStorage.getItem('rental_exposure');
	const personalInformationString = window.localStorage.getItem(
		'personal_information'
	);
	let personalInformationCity;
	if (personalInformationString) {
		const personalInformation = JSON.parse(personalInformationString);
		personalInformationCity = personalInformation.main_addr_city;
	}
	const ho3Array250 = ['Polk', 'Sarasota'];
	const ho3df3Array = [
		'Broward',
		'Miami-Dade',
		'Orange',
		'Osceola',
		'Palm Beach',
		'Seminole',
	];
	let ho3Value = 200000;
	let df3Value = 125000;
	const match = ho3Array250.some((item) =>
		personalInformationCity.toLowerCase().includes(item.toLowerCase())
	);
	const match2 = ho3df3Array.some((item) =>
		personalInformationCity.toLowerCase().includes(item.toLowerCase())
	);
	if (match) {
		ho3Value = 250000;
	} else if (match2) {
		ho3Value = 300000;
		df3Value = 150000;
	}

	if (occupancyType === 'Owner Occupied') {
		if (value >= ho3Value && value <= 2000000) {
			matches.add('HO3');
		}
		if (value >= 500000 && value <= 5000000) {
			matches.add('HO5');
		}
		if (value >= df3Value && value <= 1000000) {
			matches.add('DF3-DO');
		}
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	} else if (occupancyType === 'Immediate Family' && rentalExposure === '1') {
		if (value >= ho3Value && value <= 2000000) {
			matches.add('HO3');
		}
		if (value >= 500000 && value <= 2500000) {
			matches.add('HO5');
		}
		if (value >= df3Value && value <= 1000000) {
			matches.add('DF3-DO');
		}
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	} else if (
		(occupancyType === 'Immediate Family' && rentalExposure === '2') ||
		occupancyType === 'Tenant Occupied' ||
		occupancyType === 'Vacant'
	) {
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	}

	const orderedMatches = ['HO3', 'HO5', 'DF3-DO', 'DF1'];
	const filteredType = orderedMatches.filter((match) => matches.has(match));
	localStorage.setItem('applicableQuoteTypes', JSON.stringify(filteredType));
	return filteredType;
}

export function getLandlordMatchingType(value) {
	const matches = new Set();
	const occupancyType = window.localStorage.getItem('occupancy_type');
	const rentalExposure = window.localStorage.getItem('rental_exposure');
	const personalInformationString = window.localStorage.getItem(
		'personal_information'
	);
	let personalInformationCity;
	if (personalInformationString) {
		const personalInformation = JSON.parse(personalInformationString);
		personalInformationCity = personalInformation.main_addr_city;
	}
	const ho3df3Array = [
		'Broward',
		'Miami-Dade',
		'Orange',
		'Osceola',
		'Palm Beach',
		'Seminole',
	];
	let df3Value = 125000;
	const match = ho3df3Array.some((item) =>
		personalInformationCity.toLowerCase().includes(item.toLowerCase())
	);
	if (match) {
		df3Value = 150000;
	}

	if (occupancyType === 'Owner Occupied') {
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	} else if (occupancyType === 'Immediate Family' && rentalExposure === '1') {
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	} else if (occupancyType === 'Immediate Family' && rentalExposure === '2') {
		if (value >= df3Value && value <= 1000000) {
			matches.add('DF3-DL');
		}
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	} else if (occupancyType === 'Tenant Occupied') {
		if (value >= df3Value && value <= 1000000) {
			matches.add('DF3-DL');
		}
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	} else if (occupancyType === 'Vacant') {
		if (value >= 50000 && value <= 1000000) {
			matches.add('DF1');
		}
	}

	const orderedMatches = ['DF3-DL', 'DF1'];
	const filteredType = orderedMatches.filter((match) => matches.has(match));
	localStorage.setItem('applicableQuoteTypes', JSON.stringify(filteredType));
	return filteredType;
}

export function getProductVersion(covALimit) {
	const policyType = getPolicyType(covALimit);
	const productOption = getProductVersionByQuoteType(policyType);
	return productOption?.ProductId;
}

export function saveProductVersion(covALimit) {
	const policyType = getPolicyType(covALimit);
	const productOption = getProductVersionByQuoteType(policyType);

	if (!productOption) return;

	localStorage.setItem('product_version', productOption.ProductId);
	localStorage.setItem('effective_date', productOption.EffectiveDate);
}

export function getProductVersionByQuoteType(quoteType) {
	return window.APP_CONFIG.PRODUCT_CONFIGURATION.find(
		(i) => i.Type === quoteType
	);
}

export function getPolicyEffectiveDate() {
	const effectiveDateString = localStorage.getItem('effective_date');
	let effectiveDate;
	if (effectiveDateString === null) {
		return moment().format('YYYYMMDD');
	}
	const now = moment();
	const configDate = moment(effectiveDateString, 'MM/DD/YYYY');
	effectiveDate = now.toDate() < configDate.toDate() ? configDate : now;

	return effectiveDate.format('YYYYMMDD');
}

export function getPolicyExpirationDate() {
	return moment().add(1, 'years').format('YYYYMMDD');
}

export function formatDateForAPI(value) {
	if (!value) return;

	const [month, day, year] = value.split('/');
	return `${year}${day}${month}`;
}

export async function createQuoteByType(quoteType) {
	const quoteTemplate = JSON.parse(
		localStorage.getItem('quote_to_create_data')
	);
	const dtoBuilding =
		quoteTemplate.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0];
	const basicPolicy = quoteTemplate.DTOApplication[0].DTOBasicPolicy[0];
	const productVersion = getProductVersionByQuoteType(quoteType);
	const businessLine = getBusinessLine(quoteType);
	const customerRef = localStorage.getItem('customer_ref');
	const discountsData = localStorage.getItem('discounts_data');

	quoteTemplate.ByPassCustomerCreation = 'Yes';
	quoteTemplate.DTOApplication[0].CustomerRef = customerRef;
	basicPolicy.SubTypeCd = quoteType;
	basicPolicy.ProductVersionIdRef = productVersion?.ProductId;
	quoteTemplate.DTOApplication[0].DTOLine[0].LineCd = businessLine;
	quoteTemplate.DTOApplication[0].DTOLine[0].DTORisk[0].TypeCd = businessLine;
	basicPolicy.Description = businessLine;
	updateDiscounts(quoteTemplate, discountsData, quoteType);

	dtoBuilding.UsageType = 'Primary Residence, Not Rented';
	dtoBuilding.OpeningProtection = 'Hurricane';

	switch (quoteType) {
		case 'HO3':
			if (dtoBuilding.RoofCd === 'Shingles: Architectural/Dimensional')
				dtoBuilding.RoofCd = 'Shingles: Asphalt or Composition';
			break;
		case 'HO5':
			if (dtoBuilding.RoofCd === 'Shingles: Asphalt or Composition')
				dtoBuilding.RoofCd = 'Shingles: Architectural/Dimensional';
			dtoBuilding.CovELimit = '100000';
			dtoBuilding.CovFLimit = '1000';
			break;
		case 'HO4':
			basicPolicy.PurchaseDt = '20220101';
			dtoBuilding.OccupancyType = 'Tenant Occupied';
			dtoBuilding.UsageType = 'Rental Only';
			dtoBuilding.CovCLimit = dtoBuilding.CovCLimit;
			dtoBuilding.CovELimit = '100000';
			dtoBuilding.CovFLimit = '100';
			dtoBuilding.RentalTerm = 'Annual';
			dtoBuilding.RoofCoverAgeClass =
				+dtoBuilding.YearRoofBuilt > 2001 ? 'FBC' : 'Non-FBC';
			if (!dtoBuilding.LocationOfTerrain)
				dtoBuilding.LocationOfTerrain = 'Terrain B';
			if (!dtoBuilding.WindSpeedDesign)
				dtoBuilding.WindSpeedDesign = '100 mph or greater';
			if (!dtoBuilding.DesignExposure)
				dtoBuilding.DesignExposure = 'Standard';
			if (!dtoBuilding.WindSpeedLocation)
				dtoBuilding.WindSpeedLocation = '100 mph';
			if (!dtoBuilding.BuildingCodeGrade)
				dtoBuilding.BuildingCodeGrade = 'Non-Participating (98)';
			if (!dtoBuilding.ProtectionClass) dtoBuilding.ProtectionClass = '3';
			if (!dtoBuilding.FeetToHydrantOrWaterSource)
				dtoBuilding.FeetToHydrantOrWaterSource = '0-1,000';
			if (+dtoBuilding.NumberOfStories > 3)
				dtoBuilding.ProtectionClass = '4';
			if (!dtoBuilding.NumberOfStoriesUnit)
				dtoBuilding.NumberOfStoriesUnit = '1';
			break;
		case 'HO6':
			basicPolicy.PurchaseDt = '20220101';
			const ho6Ot = localStorage.getItem('occupancy_type');
			if (ho6Ot) {
				const ho6Re = localStorage.getItem('rental_exposure');
				dtoBuilding.OccupancyType = getHO6OccupancyType(ho6Ot);
				dtoBuilding.UsageType = getUsageType('HO6', ho6Ot, ho6Re);
			}
			dtoBuilding.CovCLimit = Math.max(20000, Math.round(
				Number(dtoBuilding.CovALimit) * Number(dtoBuilding.CovCLimitPct)
			));
			dtoBuilding.CovELimit = '100000';
			dtoBuilding.CovFLimit = '100';
			dtoBuilding.RentalTerm = 'Annual';
			dtoBuilding.RoofCoverAgeClass =
				+dtoBuilding.YearRoofBuilt > 2001 ? 'FBC' : 'Non-FBC';
			if (!dtoBuilding.LocationOfTerrain)
				dtoBuilding.LocationOfTerrain = 'Terrain B';
			if (!dtoBuilding.WindSpeedDesign)
				dtoBuilding.WindSpeedDesign = '100 mph or greater';
			if (!dtoBuilding.DesignExposure)
				dtoBuilding.DesignExposure = 'Standard';
			if (!dtoBuilding.WindSpeedLocation)
				dtoBuilding.WindSpeedLocation = '100 mph';
			if (!dtoBuilding.BuildingCodeGrade)
				dtoBuilding.BuildingCodeGrade = 'Non-Participating (98)';
			if (!dtoBuilding.ProtectionClass) dtoBuilding.ProtectionClass = '3';
			if (!dtoBuilding.FeetToHydrantOrWaterSource)
				dtoBuilding.FeetToHydrantOrWaterSource = '0-1,000';
			if (+dtoBuilding.NumberOfStories > 3)
				dtoBuilding.NumberOfStories = '4';
			if (!dtoBuilding.NumberOfStoriesUnit)
				dtoBuilding.NumberOfStoriesUnit = '1';
			break;
		case 'DF3-DL':
			basicPolicy.PurchaseDt = '20220101';
			if (dtoBuilding.RoofCd === 'Shingles: Architectural/Dimensional')
				dtoBuilding.RoofCd = 'Shingles: Asphalt or Composition';
			dtoBuilding.CovCLimit = '25000';
			dtoBuilding.CovPLimit = '100000';
			dtoBuilding.CovMLimit = '1000';
			dtoBuilding.UsageType = 'Primary Residence, Rented';
			dtoBuilding.RentalTerm = 'Annual';
			dtoBuilding.HurricaneDed = '1000';
			if (!dtoBuilding.BuildingCodeGrade)
				dtoBuilding.BuildingCodeGrade = 'Non-Participating (98)';
			if (!dtoBuilding.FeetToHydrantOrWaterSource)
				dtoBuilding.FeetToHydrantOrWaterSource = '0-1,000';
			if (!dtoBuilding.ProtectionClass) dtoBuilding.ProtectionClass = '3';
			if (!dtoBuilding.NumberOfStories) dtoBuilding.NumberOfStories = '1';
			else if (+dtoBuilding.NumberOfStories > 3)
				dtoBuilding.NumberOfStories = '4';
			break;
		case 'DF3-DO':
			basicPolicy.PurchaseDt = '20220101';
			if (dtoBuilding.RoofCd === 'Shingles: Architectural/Dimensional')
				dtoBuilding.RoofCd = 'Shingles: Asphalt or Composition';
			if (dtoBuilding.UsageType === 'Primary Residence, Not Rented') {
				dtoBuilding.CovLLimit = '100000';
			} else {
				dtoBuilding.CovPLimit = '100000';
			}
			dtoBuilding.CovMLimit = '1000';
			dtoBuilding.CovCLimit = Math.round(
				Number(dtoBuilding.CovALimit) * Number(dtoBuilding.CovCLimitPct)
			);
			dtoBuilding.HurricaneDed = '.02';
			if (!dtoBuilding.BuildingCodeGrade)
				dtoBuilding.BuildingCodeGrade = 'Non-Participating (98)';
			if (!dtoBuilding.FeetToHydrantOrWaterSource)
				dtoBuilding.FeetToHydrantOrWaterSource = '0-1,000';
			if (!dtoBuilding.ProtectionClass) dtoBuilding.ProtectionClass = '3';
			if (!dtoBuilding.NumberOfStories) dtoBuilding.NumberOfStories = '1';
			else if (+dtoBuilding.NumberOfStories > 3)
				dtoBuilding.NumberOfStories = '4';
			break;
		case 'DF1':
			const ot = localStorage.getItem('occupancy_type');
			if (ot) {
				const ut = getUsageType(quoteType, ot);
				dtoBuilding.OccupancyType = ot;
				dtoBuilding.UsageType = ut;
			}
			basicPolicy.PurchaseDt = '20220101';
			if (dtoBuilding.RoofCd === 'Shingles: Architectural/Dimensional')
				dtoBuilding.RoofCd = 'Shingles: Asphalt or Composition';
			if (dtoBuilding.UsageType === 'Primary Residence, Not Rented') {
				dtoBuilding.CovLLimit = '100000';
			} else {
				dtoBuilding.CovPLimit = '100000';
			}
			dtoBuilding.CovMLimit = '1000';
			dtoBuilding.CovDLimitPct = '0.02';
			dtoBuilding.HurricaneDed = '1000';
			dtoBuilding.CovDLimit = Math.round(
				Number(dtoBuilding.CovALimit) * Number(dtoBuilding.CovDLimitPct)
			);
			dtoBuilding.CovCLimit = Math.round(
				Number(dtoBuilding.CovALimit) * Number(dtoBuilding.CovCLimitPct)
			);
			dtoBuilding.CovBLimit = Math.round(
				Number(dtoBuilding.CovALimit) * Number(dtoBuilding.CovBLimitPct)
			);
			if (!dtoBuilding.BuildingCodeGrade)
				dtoBuilding.BuildingCodeGrade = 'Non-Participating (98)';
			if (!dtoBuilding.FeetToHydrantOrWaterSource)
				dtoBuilding.FeetToHydrantOrWaterSource = '0-1,000';
			if (!dtoBuilding.ProtectionClass) dtoBuilding.ProtectionClass = '3';
			if (!dtoBuilding.NumberOfStories) dtoBuilding.NumberOfStories = '1';
			else if (+dtoBuilding.NumberOfStories > 3)
				dtoBuilding.NumberOfStories = '4';
			dtoBuilding.RentalTerm = 'Annual';
			break;
	}

	const quoteString = JSON.stringify(quoteTemplate);
	return await createAdditionalQuote(quoteString);
}

export function updateDiscounts(quote, discountsData, quoteType) {
	if (discountsData.militaryDiscount && quoteType === 'HO3')
		quote.DTOApplication[0].DTOLine[0].MilitaryFirstResponderInd = 'Yes';
	else if (quoteType === 'HO3')
		quote.DTOApplication[0].DTOLine[0].MilitaryFirstResponderInd = 'No';
	if (discountsData.years54Discount)
		quote.DTOApplication[0].DTOInsured[0].PartyInfo[0].PersonInfo[0].BirthDt =
			calculateBirthDate(55);
	else
		quote.DTOApplication[0].DTOInsured[0].PartyInfo[0].PersonInfo[0].BirthDt =
			'20000101';
	if (discountsData.gatedCommunityDiscount)
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].GateGuarded =
			'Single Entry or 24 hr Patrol';
	else
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].GateGuarded =
			'None';
	if (discountsData.alarmDiscount)
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].BurglarAlarmCd =
			'Central Monitoring Station';
	else
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].BurglarAlarmCd =
			'None';
	if (discountsData.waterDiscount && quoteType === 'HO3')
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].WaterMonitoringSystem =
			'Water Detection Device with Automatic Shut-Off';
	else if (quoteType === 'HO3')
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].WaterMonitoringSystem =
			'None';
	if (discountsData.shutterDiscount)
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].OpeningProtection =
			'Hurricane';
	else
		quote.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].OpeningProtection =
			'Basic';
}

function calculateBirthDate(ageInYears) {
	const today = new Date();
	const birthDate = new Date(today);

	birthDate.setFullYear(birthDate.getFullYear() - ageInYears);

	birthDate.setDate(birthDate.getDate() - 40);

	const mm = String(birthDate.getMonth() + 1).padStart(2, '0');
	const dd = String(birthDate.getDate()).padStart(2, '0');
	const yyyy = birthDate.getFullYear();

	return yyyy + mm + dd;
}
